"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNonce = exports.toUnitless = exports.toHuman = exports.bnOrZero = exports.parseBN = exports.BN_10000 = exports.BN_ZERO = exports.BN_ONE = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.BN_ONE = new bignumber_js_1.default(1);
exports.BN_ZERO = new bignumber_js_1.default(0);
exports.BN_10000 = new bignumber_js_1.default(10000);
const parseBN = (input, defaultValue) => {
    if (!input && input !== 0)
        return defaultValue;
    const result = bignumber_js_1.default.isBigNumber(input) ? input : new bignumber_js_1.default(input);
    if (!result.isFinite() || result.isNaN())
        return defaultValue;
    return result;
};
exports.parseBN = parseBN;
const bnOrZero = (input, defaultValue = exports.BN_ZERO) => {
    return exports.parseBN(input, defaultValue);
};
exports.bnOrZero = bnOrZero;
const toHuman = (value, decimals) => {
    if (value === undefined || value === null)
        return undefined;
    const valueBN = exports.bnOrZero(value);
    if (!decimals)
        return valueBN; // decimals = 0 or nullish
    const decimalsBN = exports.bnOrZero(decimals);
    return valueBN.shiftedBy(decimalsBN.negated().toNumber());
};
exports.toHuman = toHuman;
const toUnitless = (value, decimals) => {
    if (value === undefined || value === null)
        return undefined;
    const valueBN = exports.bnOrZero(value);
    if (!decimals)
        return valueBN; // decimals = 0 or nullish
    const decimalsBN = exports.bnOrZero(decimals);
    return valueBN.shiftedBy(decimalsBN.toNumber());
};
exports.toUnitless = toUnitless;
const generateNonce = () => {
    return Math.floor(Math.random() * 1000000);
};
exports.generateNonce = generateNonce;
